import * as Sentry from '@sentry/react';
const FULLY_QUALIFIED_ENVIRONMENT = `${process.env.APP_ENV}-${process.env.APP_MODE}`;
Sentry.init({
    environment: FULLY_QUALIFIED_ENVIRONMENT,
    dsn: process.env.SENTRY_DSN,
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: ['localhost', /^https:\/\/pali-orchestrator-prod-live\.xendit\.co/]
        })
    ],
    tracesSampleRate: 0
});
